export const SCRIPTS_CONSTANTS = [
    {
        id: 2057,
        script: `{
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "Բակտրիմ ֆորտե - Բրոնխիտի բուժման համար",
            "image": "https://alfapharm.am/product-images/big/00013166.png",
            "description": "Բակտրիմ ֆորտե՝ դեղամիջոց բրոնխիտի բուժման համար: Նպաստում է շնչառական վարակների կանխարգելմանը և արագ ապաքինմանը։",
            "brand": {
              "@type": "Brand",
              "name": "Bactrim"
            },
            "sku": "2057",
            "offers": {
              "@type": "Offer",
              "url": "https://alfapharm.am/hy/products/details/2057/%D5%A2%D5%A1%D5%AF%D5%BF%D6%80%D5%AB%D5%B4-%D5%B8%D6%80%D5%BF%D5%A5-%D5%A4%D5%B0%D5%BF-800160-x-10",
              "priceCurrency": "AMD",
              "price": "5400",
              "availability": "https://schema.org/InStock"
            }
        }`
    },
    {
        id: 2055,
        script: `{
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "Բակտրիմ կախույթ - Մանկական բրոնխիտի բուժում",
            "image": "https://alfapharm.am/product-images/big/00008245.png",
            "brand": {
              "@type": "Brand",
              "name": "Bactrim"
            },
            "sku": "2055",
            "offers": {
              "@type": "Offer",
              "url": "https://alfapharm.am/hy/products/details/2055/%D5%A2%D5%A1%D5%AF%D5%BF%D6%80%D5%AB%D5%B4-%D5%AF%D5%A1%D5%AD%D5%B8%D6%82%D5%B5%D5%A9-2405%D5%B4%D5%AC---100%D5%B4%D5%AC",
              "priceCurrency": "AMD",
              "price": "5590"
            }
        }`
    },
    {
        id: 6329,
        script: `{
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "Ավեն Կլինանս Կոմեդոմեդ ակնեի համար",
            "image": "https://alfapharm.am/product-images/big/00035273.png",
            "description": "Ակնեի դեղամիջոց Ավեն Կլինանս Կոմեդոմեդ, որը նվազեցնում է պզուկները և կանխում նորերի առաջացումը՝ բարելավելով մաշկի առողջությունը։",
            "brand": {
              "@type": "Brand",
              "name": "Avene"
            },
            "sku": "6329",
            "offers": {
              "@type": "Offer",
              "url": "https://alfapharm.am/hy/products/details/6329/%D5%A1%D5%BE%D5%A5%D5%B6-%D5%AF%D5%AC%D5%AB%D5%B6%D5%A1%D5%B6%D5%BD-%D5%AF%D5%B8%D5%B4%D5%A5%D5%A4%D5%B8%D5%B4%D5%A5%D5%A4-30%D5%B4%D5%AC-257671",
              "priceCurrency": "AMD",
              "price": "9800",
              "availability": "https://schema.org/InStock"
            }
        }`
    },
    {
        id: 31752,
        script: `{
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "Լա Ռոշ Պոզե Էֆակլար Դուո ակնեի դեմ միջոց",
            "image": "https://alfapharm.am/product-images/big/00041574.png",
            "description": "Ակնեի դեմ միջոց Լա Ռոշ Պոզե՝ պզուկների դեմ պայքարելու համար։ Հզոր միջոց, որի շնորհիվ կունենաք ավելի հարթ և մաքուր մաշկ:",
            "brand": {
              "@type": "Brand",
              "name": "La Roche-Posay"
            },
            "sku": "31752",
            "offers": {
              "@type": "Offer",
              "url": "https://alfapharm.am/hy/products/details/31752/%D5%AC%D5%A1-%D5%BC%D5%B8%D5%B7-%D5%BA%D5%B8%D5%A6%D5%A5-%D5%A7%D5%A1%D5%AF%D5%AC%D5%A1%D6%80-%D5%A4%D5%B8%D6%82%D5%B8%D5%B4-%D5%B7%D5%BF%D5%AF%D5%B8%D5%B2-%D5%B4%D5%AB%D5%BB%D5%B8%D6%81-%D5%A1%D5%B6%D5%B0%D5%A1%D6%80%D5%A9%D5%B8%D6%82%D5%A9%D5%B5%D5%B8%D6%82%D5%B6%D5%B6%D5%A5%D6%80%D5%AB-%D5%A4%D5%A5%D5%B4-40%D5%B4%D5%AC",
              "priceCurrency": "AMD",
              "price": "8700",
              "availability": "https://schema.org/InStock"
            }
        }`
    },
    {
        id: 30709,
        script: `{
            "@context": "https://schema.org/", 
            "@type": "Product", 
            "name": "Ավեն արևապաշտպան քսուք Triasorb SPF50+",
            "image": "https://alfapharm.am/product-images/big/00040557.png",
            "description": "Արևապաշտպան քսուք Avene - պաշտպանում է ուլտրամանուշակագույն ճառագայթներից՝ պահպանելով ձեր մաշկը խոնավ և փայլուն:",
            "brand": {
              "@type": "Brand",
              "name": "Avene"
            },
            "offers": {
              "@type": "Offer",
              "url": "https://alfapharm.am/hy/products/details/30709/%D5%A1%D5%BE%D5%A5%D5%B6-%D5%A1%D6%80%D5%A1%D5%BA%D5%A1%D5%B7%D5%BF%D5%BA%D5%A1%D5%B6-%D5%AC%D5%B5%D5%B8%D6%82%D5%AB%D5%A4-triasorb-spf50-50%D5%B4%D5%AC-259390",
              "priceCurrency": "AMD",
              "price": "10800",
              "availability": "https://schema.org/InStock"
            }
        }`
    },
    {
        id: 27652,
        script: `{
             "@context": "https://schema.org/", 
             "@type": "Product", 
             "name": "Արևապաշտպան կրեմ Avene SPF 50+",
             "image": "https://alfapharm.am/product-images/big/00038319.png",
             "description": "Արևապաշտպան կրեմ Avene SPF 50+: Կատարյալ է զգայուն մաշկի համար։ Պաշտպանեք ձեր մաշկը արևից ֆրանսիական Avene ապրանքանիշի հետ:",
             "brand": {
               "@type": "Brand",
               "name": "Avene"
             },
             "sku": "259402",
             "offers": {
               "@type": "Offer",
               "url": "https://alfapharm.am/hy/products/details/27652/%D5%A1%D5%BE%D5%A5%D5%B6-%D5%A1%D6%80%D5%A1%D5%BA%D5%A1%D5%B7%D5%BF%D5%BA%D5%A1%D5%B6-%D5%AB%D5%B6%D5%BF%D5%A5%D5%B6%D5%BD-%D5%BA%D6%80%D5%B8%D5%BF%D5%A5%D5%AF%D5%BF-%D5%AC%D5%B5%D5%B8%D6%82%D5%AB%D5%A4-spf50-150%D5%B4%D5%AC-259402",
               "priceCurrency": "AMD",
               "price": "12000",
               "availability": "https://schema.org/InStock"
             }
        }`
    },
    {
        id: 30269,
        script: `{
             "@context": "https://schema.org/", 
             "@type": "Product", 
             "name": "Ավեն արևապաշտպան կրեմ յուղոտ, ակնեի հակված մաշկի համար Triasorb SPF50+",
             "image": "https://alfapharm.am/product-images/big/00039883.png",
             "description": "Արևապաշտպան քսուք Triasorb տեխնոլոգիայով։ Պաշտպանեք և խնամեք յուղոտ, ակնեի հակված մաշկը Avene Sun Care Cleanance SPF 50+-ով:",
             "brand": {
               "@type": "Brand",
               "name": "Avene"
             },
             "offers": {
               "@type": "Offer",
               "url": "https://alfapharm.am/hy/products/details/30269/%D5%A1%D5%BE%D5%A5%D5%B6-%D5%A1%D6%80%D5%A1%D5%BA%D5%A1%D5%B7%D5%BF%D5%BA%D5%A1%D5%B6-%D5%AF%D6%80%D5%A5%D5%B4-%D5%B5%D5%B8%D6%82%D5%B2%D5%B8%D5%BF-%D5%A1%D5%AF%D5%B6%D5%A5%D5%AB-%D5%B0%D5%A1%D5%AF%D5%BE%D5%A1%D5%AE-%D5%B4%D5%A1%D5%B7%D5%AF%D5%AB-%D5%B0%D5%A1%D5%B4%D5%A1%D6%80-triasorb-spf50-50%D5%B4%D5%AC",
               "priceCurrency": "AMD",
               "price": "9700",
               "availability": "https://schema.org/InStock"
             }
        }`
    },
    {
        id: 5168,
        script: `{
              "@context": "https://schema.org/", 
              "@type": "Product", 
              "name": "Քոլդրեքս մաքս գրիպ՝ մրսածության և գրիպի դեմ",
              "image": "https://alfapharm.am/product-images/big/00012155.png",
              "description": "Քոլդրեքս Մաքս Գրիպ x10՝ արագ միջոց մրսածության և գրիպի ախտանիշների դեմ (ջերմություն, գլխացավ, կոկորդի ցավ, թուլություն:",
              "brand": {
                "@type": "Brand",
                "name": "Coldrex"
              },
              "sku": "5168",
              "offers": {
                "@type": "Offer",
                "url": "https://alfapharm.am/hy/products/details/5168/%D6%84%D5%B8%D5%AC%D5%A4%D6%80%D5%A5%D6%84%D5%BD-%D5%B4%D5%A1%D6%84%D5%BD-%D5%A3%D6%80%D5%AB%D5%BA-x-10",
                "priceCurrency": "AMD",
                "price": "4940",
                "availability": "https://schema.org/InStock"
              }
        }`
    },
    {
        id: 6544,
        script: `{
               "@context": "https://schema.org/", 
               "@type": "Product", 
               "name": "Ասթմոիդ բրոնխիտ - Դենկ-Էիր Ջունիոր",
               "image": "https://alfapharm.am/product-images/big/00032271.png",
               "description": "Դենկ-Էիր Ջունիոր՝ հակաալերգիկ դեղամիջոց, որը նախատեսված է ասթմոիդ բրոնխիտի և այլ շնչառական խնդիրների բուժման համար:",
               "brand": {
                 "@type": "Brand",
                 "name": "Denk-Air"
               },
               "sku": "6544",
               "offers": {
                 "@type": "Offer",
                 "url": "https://alfapharm.am/hy/products/details/6544/%D5%A4%D5%A5%D5%B6%D5%AF-%D5%A7%D5%AB%D6%80-%D5%BB%D5%B8%D6%82%D5%B6%D5%AB%D5%B8%D6%80-%D5%AE%D5%A1%D5%B4-%D5%A4%D5%B0%D5%BF-5%D5%B4%D5%A3-x-28",
                 "priceCurrency": "AMD",
                 "price": "7570"
               }
        }`
    },
    {
        id: 5153,
        script: `{
               "@context": "https://schema.org/", 
               "@type": "Product", 
               "name": "Դյուքրեյ շամպուն թեփի և սեբորեայի դեմ",
               "image": "https://alfapharm.am/product-images/big/00033414.png",
               "description": "Դյուքրեյ Կելյուալ ԴՍ շամպուն թեփի դեմ՝ ծանր աստիճանի թեփոտության և սեբորեային դերմատիտի համար: Նվազեցնում է թեփը, հանգստացնում գլխամաշկը և ապահովում մազերի խնամք։",
               "brand": {
                 "@type": "Brand",
                 "name": "Ducray"
               },
               "sku": "5153",
               "offers": {
                 "@type": "Offer",
                 "url": "https://alfapharm.am/hy/products/details/5153/%D5%A4%D5%B5%D5%B8%D6%82%D6%84%D6%80%D5%A5%D5%B5-%D5%AF%D5%A5%D5%AC%D5%B5%D5%B8%D6%82%D5%A1%D5%AC-%D5%A4%D5%BD-%D5%B7%D5%A1%D5%B4%D5%BA%D5%B8%D6%82%D5%B6-%D5%AE%D5%A1%D5%B6%D6%80-%D5%A1%D5%BD%D5%BF%D5%AB%D5%B3%D5%A1%D5%B6%D5%AB-%D5%A9%D5%A5%D6%83%D5%B8%D5%BF%D5%B8%D6%82%D5%A9%D5%B5%D5%A1%D5%B6-%D5%A5%D6%82-%D5%BD%D5%A5%D5%A2%D5%B8%D6%80%D5%A5%D5%A1%D5%B5%D5%AB%D5%B6-%D5%A4%D5%A5%D6%80%D5%B4%D5%A1%D5%BF%D5%AB%D5%BF%D5%AB-%D5%A4%D5%A5%D5%B4-100%D5%B4%D5%AC",
                 "priceCurrency": "AMD",
                 "price": "7100",
                 "availability": "https://schema.org/InStock"
               }
        }`
    },
    {
        id: 179,
        script: `{
               "@context": "https://schema.org",
               "@type": "BlogPosting",
               "headline": "Ակնեի առաջացման պատճառները․ ակնե հիվանդություն, ",
               "description": "Բլոգում քննարկվում են ակնեի առաջացման հիմնական պատճառները, ներառյալ հորմոնալ փոփոխությունները, սթրեսը, սննդակարգը և շրջակա միջավայրը, ինչպես նաև դրանց դեմ պայքարի միջոցները:",
               "url": "https://alfapharm.am/hy/blogs/179/aknei-aeajacman-patcharnere",
               "author": {
                 "@type": "Organization",
                 "name": "Alfapharm"
               },
               "publisher": {
                 "@type": "Organization",
                 "name": "Alfapharm",
                 "logo": {
                   "@type": "ImageObject",
                   "url": "https://alfapharm.am/path-to-logo.jpg"
                 }
               },
               "datePublished": "2025-02-13",
               "mainEntityOfPage": "https://alfapharm.am/hy/blogs/179/aknei-aeajacman-patcharnere"
        }`
    },
    {
        id: 27643,
        script: `{
               "@context": "https://schema.org/", 
               "@type": "Product", 
               "name": "Դյուքրեյ Կերակնիլ ՊՊ+ կրեմ ակնեի բշտերի և հետքերի դեմ",
               "image": "https://alfapharm.am/product-images/big/00038336.png",
               "description": "Դյուքրեյ Կերակնիլ ՊՊ+ կրեմ՝ արդյունավետ լուծում դեմքի և մեջքի ակնեի բշտերի և հետքերի դեմ: Նվազեցնում է բշտերը, մաքրում մաշկը։",
               "brand": {
                 "@type": "Brand",
                 "name": "Ducray"
               },
               "offers": {
                 "@type": "Offer",
                 "url": "https://alfapharm.am/hy/products/details/27643/%D5%A4%D5%B5%D5%B8%D6%82%D6%84%D6%80%D5%A5%D5%B5-%D5%AF%D5%A5%D6%80%D5%A1%D5%AF%D5%B6%D5%AB%D5%AC-%D5%BA%D5%BA-%D5%AF%D6%80%D5%A5%D5%B4-%D5%A1%D5%AF%D5%B6%D5%A5%D5%AB-%D5%A2%D5%B7%D5%BF%D5%A5%D6%80%D5%AB-%D5%B0%D5%A5%D5%BF%D6%84%D5%A5%D6%80%D5%AB-%D5%A4%D5%A5%D5%B4-30%D5%B4%D5%AC",
                 "priceCurrency": "AMD",
                 "price": "7500",
                 "availability": "https://schema.org/InStock"
               }
        }`
    },
    {
        id: 27649,
        script: `{
               "@context": "https://schema.org/", 
               "@type": "Product", 
               "name": "Դյուքրեյ Կերակնիլ Գլիկոլիկ+ կրեմ սև և սպիտակ կետերի դեմ",
               "image": "https://alfapharm.am/product-images/big/00038335.png",
               "description": "Հատուկ մշակված մաշկային ակնեի և սև ու սպիտակ կետերի դեմ Դյուքրեյ Կերակնիլ Գլիկոլիկ+ կրեմ: Նվազեցնում է կետերը, մաքրում մաշկը։",
               "brand": {
                 "@type": "Brand",
                 "name": "Ducray"
               },
               "offers": {
                 "@type": "Offer",
                 "url": "https://alfapharm.am/hy/products/details/27649/%D5%A4%D5%B5%D5%B8%D6%82%D6%84%D6%80%D5%A5%D5%B5-%D5%AF%D5%A5%D6%80%D5%A1%D5%AF%D5%B6%D5%AB%D5%AC-%D5%A3%D5%AC%D5%AB%D5%AF%D5%B8%D5%AC%D5%AB%D5%AF-%D5%AF%D6%80%D5%A5%D5%B4-%D5%BD-%D5%BD%D5%BA%D5%AB%D5%BF%D5%A1%D5%AF-%D5%AF%D5%A5%D5%BF%D5%A5%D6%80%D5%AB-%D5%A4%D5%A5%D5%B4-30%D5%B4%D5%AC",
                 "priceCurrency": "AMD",
                 "price": "8300",
                 "availability": "https://schema.org/InStock"
               }
        }`
    },
];
